module.exports = __webpack_public_path__ + "static/Robert_Kridel_headshot_lores-e4f2ea5d627ac974df1c8f8a924d7857.png";